<template>
  <div>
    <Login v-if="page === 'login'" :error="error" />
    <Card v-if="page === 'card'" />
    <List v-if="page === 'list'" :items="items" />
  </div>
</template>

<script>
import Card from './components/Card.vue';
import Login from './components/Login.vue';
import List from './components/List.vue';

const { GoogleSpreadsheet } = require('google-spreadsheet');

export default {
  name: 'App',
  data() {
    return {
      error: null,
      page: 'login',
      password: null,
      items: [],
    };
  },

  created() {
    this.$root.$on('login', this.login);
    this.$root.$on('changePage', this.changePage);
    this.$root.$on('fetchItems', this.fetchItems);
    this.$root.$on('purchaseItem', this.purchaseItem);
  },

  components: {
    Card,
    Login,
    List,
  },

  methods: {

    async fetchItems() {
      // Initialize the sheet - doc ID is the long id in the sheets URL
      const doc = new GoogleSpreadsheet('1gcEyVcppZBqSHMD9u4P3hXrBYEZphT2FqFMRWm7St10');

      // Initialize Auth
      // TODO-erik: use process.env.GOOGLE_SERVICE_ACCOUNT_EMAIL...
      await doc.useServiceAccountAuth({
        client_email: 'vandeputtemerckxbaby@vandeputtemerckxbaby.iam.gserviceaccount.com',
        private_key: '-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCy+LLeBqNqu2NQ\nX556aQGo5kJhYjjZp5Mbvyy/HPvsEc4hCqtqzgMmJb4Ac4HprkMT+EDtYi86ZtWv\nyJoQas8r+rF7lf4cuefAlWrPdxS4mZ4Z2bUYNSWUmUfG+MzJBimCQN8SoOyCpP5X\nkUR/HLpF78nMDn1pnLLMTkyevp04MnZfwHZ07pQ+Hghc696sD/2i8hUGuvChebvr\nCKv71+cNw9GFRuE8arHQTJJ1+RkU3JRS38lngcds4CIF5Ob6VAUY0DaMlRoaYD2m\n5UlKYDIo5WCYNLcxSTiDKGtX528MEm9etB1mKTJkeXgk8U73d54lrFq9dUp0f27O\nb8vQ6PBVAgMBAAECggEAAwXXfY+xTxJFrJFE4Q6Tetm9bsgk1iucp41nJn4z6hTo\nkp8hGI93YaZQYHu9oBJeVdYYVfoVz/Ughaohd1wFI5obHnorfdWNABrLSvWZBGos\nelrL59ID+w/LX3q1zhe8IpP7wI82bMQie0eml3AHMbsJq+2QZDTY7Jb499MX3t+s\nu2Ze8H6u891ie68kpZ9+WozME9SBoWghX7px/njwq7vkFEOZWInUYECKfTSN51Bm\nneASqJVio1ND6kxL5s9wLYQsI0RMD+31MvSIAwlCHbiohGGqhrLqFneo1b5dEoWg\nqb1fis8mkaEwPDIp56uXXCnpzfETvG8Li2ukKY6ckQKBgQDoU3mZW/lv6IY8z6w3\nWoVoWERhAHVRDcYQAUB1GYnf7MzeI3QiOKwLRX6NsTcN1JUDV6YKg3hLQbZZ2c6/\nEoQVKBTuo12H0WRK/ILJybhJ0efERMulSdJOKzA72rqJJHb8I1tH6efZv3Wl3SJo\nskH4ACbm/rnCnwMyyVu2NHmMkQKBgQDFNWZ9JnVqDVG3TKfcpHphUoHFOZNvwxdN\n+NFu4/BeH9AyqEMyT56ZuehFKOOhZaMIFLfW6DCYlfTmUcYM+d6Me/Q8HGHMjVIb\nHrNMDEhHjUuv77B6QkDAIAVzy3Q2FimaCg7lcIgHRJxlgzYBMbnGqJcEV/CV/zQe\n7Qp3qdzZhQKBgQCFWrTntIV/GOdErKfbthfxhwjo7QxqFA/mS/GlxZ0AbbpCn/Mf\nWYxXg/JafqhtReKq4nqqekBoYjW7aWxk/MnYIwOw3xDmzuhUqpCgJyujI9t3K04B\neFhBCkVLdgewhL/PhrP0mWy97konhMEle3ymT+AEo54Y+pEpa6867PAAIQKBgE8t\nzpWHAHNxH5MR4v/SxhQXNWVDZa/ky5GRyjzUpeiUq1n7dudXUl10aA6EiUh+70NK\nVjmiBgjthGOJB5SkKjeLeRc9agLf5sxeuixZbhfUYkQkX13nBepdsPK6CFHC+jcP\nvMVgNi183bJgSSmXlnhtrhyfVkhTK9ES6TX8bGClAoGBANv3uoErYGazwSGkExOh\n3yo3Deg+KpSoYmrKyv/nD2QR65/j/+9TniQC5mt7k0rHHs9OryQicRGYtnOLJ9OU\nKj69aoipEAxWUUPJ7Tqhi3x3/N2R83E4Ha23eJ3rU0YA14/MasUX6ehnwKtNjgDr\nqPQSu3fjdqQ5gnidD/4jZXtn\n-----END PRIVATE KEY-----\n',
      });

      await doc.loadInfo(); // loads sheets
      const sheet = doc.sheetsByIndex[0];

      this.items = await sheet.getRows();
      this.items = this.items.filter((item) => item.for_sale === 'TRUE');
      console.log(this.items);
      /* eslint-disable no-param-reassign */
      this.items.forEach((a) => {
        ['is_purchased', 'for_sale'].forEach((k) => {
          a[k] = a[k] === 'TRUE';
        });
        ['price'].forEach((k) => {
          a[k] = Number(a[k]);
        });
      });
      console.log(this.items);
    },

    async login(password) {
      this.password = password ? password.toLowerCase() : '';
      this.error = null;

      if (this.password === 'welkomalice') {
        await this.fetchItems();
        this.page = 'card';
      } else {
        this.error = 'Wachtwoord is ongeldig, gelieve opnieuw te proberen.';
      }
    },

    async purchaseItem(item) {
      console.log(item);
      await item.save();
    },

    changePage(page) {
      this.page = page;
    },
  },
};
</script>
